import { put, select } from 'redux-saga/effects'
import { Action } from 'redux-actions'
import { get, set } from 'lodash-es'
import { flatten } from 'flat'

import { getOrderDateValidationContext } from 'utils/date'

import { OrderFormErrorProps } from 'types/order'

import { selectCurrentUser } from 'store/users/users.selectors'
import getOrderFormRules from 'components/organisms/OrderForm/utils/getOrderFormRules'
import formValidator from 'components/organisms/OrderForm/utils/formValidator'

import { errorsOrderHandler } from '../order.actions'
import { selectOrderWrite } from '../order.selectors'

const Validator = require('validatorjs')

export function* validationHandler(action: Action<{ [key: string]: any }>) {
  try {
    const currentUser = yield select(selectCurrentUser)
    const form = yield select(selectOrderWrite)
    const rules: { [key: string]: string | Array<string> } = getOrderFormRules(currentUser, form)
    const errors: { [key: string]: OrderFormErrorProps } = {}
    const keys = Object.keys(flatten(action.payload))

    const dateValidationContext = getOrderDateValidationContext()

    for (let i = 0; i < keys.length; i += 1) {
      if (!rules[keys[i]]) {
        set(errors, keys[i], { isValid: undefined, invalidMessage: '' })
      } else {
        const validateProperty = new Validator({ [keys[i]]: get(action.payload, keys[i]), ...dateValidationContext }, { [keys[i]]: rules[keys[i]] })
        const isValid = validateProperty.passes()
        if (rules[keys[i]]?.indexOf('required') === -1 && isValid) {
          set(errors, keys[i], { isValid: undefined, invalidMessage: '' })
        } else {
          set(errors, keys[i], formValidator(keys[i], isValid))
        }
      }
    }
    yield put(errorsOrderHandler(errors))
  } catch (error) {
    console.error(`[validationHandler]: ${error}`)
  }
}
